import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cbc34f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ms-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  style: {"cursor":"pointer"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "card mt-2" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "header" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["textContent"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["textContent"]
const _hoisted_21 = { key: 3 }
const _hoisted_22 = ["textContent"]

import { getEntityTranslation } from "@/helpers";
import { Tol2008TreeDto } from "@api/tol2008-tree-dto";
import { computed } from "vue";
import { PropType, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tol2008Item',
  props: {
	tol2008Item: {
		type: Object as PropType<Tol2008TreeDto>,
		required: true,
	},
	loadedTols: {
		type: Array as PropType<Tol2008TreeDto[]>,
		required: true,
	},
	selectionSingle: {
		type: Number as PropType<number | null>,
		required: true,
	},
	selectionMulti: {
		type: Array as PropType<Tol2008TreeDto[]>,
		default: () => [],
	},
},
  emits: ["expand", "close", "select", "removeSelection"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const myChildren = computed(() =>
	props.loadedTols.filter((r) => r.parentId == props.tol2008Item.id)
);

const isLoading = computed(() => props.tol2008Item.isLoading);

const isSelected = computed(() => {
	if (props.selectionSingle == props.tol2008Item.id) {
		return true;
	}

	if (props.selectionMulti?.some((r) => r.id == props.tol2008Item.id)) {
		return true;
	}

	return false;
});

const showInfo = ref(false);

const click = () => {
	if (props.tol2008Item.isLeaf) {
		showInfo.value = !showInfo.value;
	} else {
		if (props.tol2008Item.isOpen) {
			emit("close", props.tol2008Item);
		} else {
			emit("expand", props.tol2008Item);
		}
	}
};

const fixTranslation = (txt: string | undefined) => {
	if (txt == undefined) {
		return undefined;
	}
	txt = txt.replaceAll("- -", "  -");
	return txt;
};

return (_ctx: any,_cache: any) => {
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_Tol2008Item = _resolveComponent("Tol2008Item", true)!
  const _component_HakoSpinner = _resolveComponent("HakoSpinner")!
  const _component_HakoButton = _resolveComponent("HakoButton")!
  const _component_HakoCollapse = _resolveComponent("HakoCollapse")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex align-items-center", { 'tol': true, 'is-open': __props.tol2008Item.isOpen || showInfo.value }])
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle({ width: `${__props.tol2008Item.level * 10}px`, height: '24px' })
      }, null, 4),
      _createElementVNode("div", {
        class: "d-flex align-items-center",
        style: {"cursor":"pointer"},
        onClick: _withModifiers(click, ["stop","prevent"])
      }, [
        _createTextVNode(_toDisplayString(__props.tol2008Item.rootCode) + " " + _toDisplayString(__props.tol2008Item.code) + ": " + _toDisplayString(_unref(getEntityTranslation)(__props.tol2008Item.translations, "name")) + " ", 1),
        _createElementVNode("span", _hoisted_1, [
          (
							(!__props.tol2008Item.isLeaf && !__props.tol2008Item.isOpen) ||
							(__props.tol2008Item.isLeaf && !showInfo.value)
						)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _createVNode(_component_HakoBsIcon, { icon: "plus-square" })
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createVNode(_component_HakoBsIcon, { icon: "dash-square" })
              ]))
        ])
      ])
    ], 2),
    (!__props.tol2008Item.isLeaf)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (myChildren.value.length > 0 && __props.tol2008Item.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myChildren.value, (c) => {
                  return (_openBlock(), _createBlock(_component_Tol2008Item, {
                    key: c.id?.toString(),
                    tol2008Item: c,
                    loadedTols: __props.loadedTols,
                    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close', $event))),
                    onExpand: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('expand', $event))),
                    onSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('select', $event))),
                    onRemoveSelection: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('removeSelection', $event))),
                    selectionSingle: __props.selectionSingle,
                    selectionMulti: __props.selectionMulti
                  }, null, 8, ["tol2008Item", "loadedTols", "selectionSingle", "selectionMulti"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_HakoSpinner, { sm: "" })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_HakoCollapse, { show: showInfo.value }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h5", null, _toDisplayString(__props.tol2008Item.rootCode) + " " + _toDisplayString(__props.tol2008Item.code) + " " + _toDisplayString(_unref(getEntityTranslation)(__props.tol2008Item.translations, "name")), 1)
                          ]),
                          _createElementVNode("div", null, [
                            (!isSelected.value)
                              ? (_openBlock(), _createBlock(_component_HakoButton, {
                                  key: 0,
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('select', __props.tol2008Item))),
                                  isBlock: "",
                                  sm: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("generic.select")), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_HakoButton, {
                                  key: 1,
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('removeSelection', __props.tol2008Item))),
                                  theme: "danger",
                                  isBlock: "",
                                  sm: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("generic.removeSelection")), 1)
                                  ]),
                                  _: 1
                                })),
                            _createVNode(_component_HakoButton, {
                              theme: "light",
                              class: "mt-2",
                              isBlock: "",
                              sm: "",
                              onClick: _withModifiers(click, ["stop","prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("generic.close")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_14,
                  (_unref(getEntityTranslation)(__props.tol2008Item.translations, 'generalNote'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("tol.info")) + ":", 1),
                        _createElementVNode("pre", {
                          textContent: _toDisplayString(
									fixTranslation(
										_unref(getEntityTranslation)(__props.tol2008Item.translations, 'generalNote')
									)
								)
                        }, null, 8, _hoisted_16)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(getEntityTranslation)(__props.tol2008Item.translations, 'includes'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("tol.includes")) + ":", 1),
                        _createElementVNode("pre", {
                          textContent: _toDisplayString(
									fixTranslation(
										_unref(getEntityTranslation)(__props.tol2008Item.translations, 'includes')
									)
								)
                        }, null, 8, _hoisted_18)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(getEntityTranslation)(__props.tol2008Item.translations, 'includesAlso'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("tol.includesAlso")) + ":", 1),
                        _createElementVNode("pre", {
                          textContent: _toDisplayString(
									fixTranslation(
										_unref(getEntityTranslation)(__props.tol2008Item.translations, 'includesAlso')
									)
								)
                        }, null, 8, _hoisted_20)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(getEntityTranslation)(__props.tol2008Item.translations, 'excludes'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("tol.excludes")) + ":", 1),
                        _createElementVNode("pre", {
                          textContent: _toDisplayString(
									fixTranslation(
										_unref(getEntityTranslation)(__props.tol2008Item.translations, 'excludes')
									)
								)
                        }, null, 8, _hoisted_22)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ]))
  ]))
}
}

})